import { Routes, Route, Outlet } from 'react-router-dom';
import RegisterAccount from './pages/RegisterAccount';
import { useAuth0 } from '@auth0/auth0-react';
import CreateAddress from './pages/address/CreateAddress';
import TransactionsPage from './pages/familiplus/TransactionsPage';
import FamiliplusBase from './pages/familiplus/FamiliplusBase';
import FamiliplusOESDonations from './pages/familiplus/FamiliplusOESDonations';
import FamiliplusSummaryPage from './pages/familiplus/FamiliplusSummaryPage';
import PreferencesBase from './pages/preferences/PreferencesBase';
import ShoppingPage from './pages/preferences/ShoppingPage';
import CommunicationPage from './pages/preferences/CommunicationPage';
import { setupAuth as setupFLSApiClientAuth } from './common/FLSApiClient';
import { getRegistrationToken } from './services/RegisterService';
import FamiliplusCardPage from './pages/familiplus/familiplusCard/FamiliplusCardPage';
import FamiliplusReplaceCard from './pages/familiplus/familiplusCard/FamiliplusReplaceCard';
import MainBase from 'pages/MainBase';
import AccountProfile from './pages/accountProfile/AccountProfile';
import EditAddress from 'pages/address/EditAddress';
import HomePage from './pages/HomePage';
import LangGuard from './components/routing/LangGuard';
import NotFound from './pages/NotFound';
import RequireAuthGuard from './components/routing/RequireAuthGuard';
import { Auth0TokenManager, InitAuth0TokenManager } from 'common/Auth0TokenManager';
import Redirect from 'pages/Redirect';
import ConsentPreferenceBase from 'components/common/ConsentPreferenceBase';
import PreferenceCenter from 'pages/preferences/PreferenceCenter';
import FamiliprixPageBase from 'components/common/FamiliprixPageBase';
import UnsubscribePage from 'pages/preferences/UnsubscribePage';
import ActivationConfirmation from 'pages/ActivationConfirmation';
import ActivateAccount from 'pages/ActivateAcount';
import FamiliplusSubBase from 'pages/familiplus/FamiliplusSubBase';
import AuthGuardError from 'components/routing/AuthGuardError';
import ErrorPage from 'pages/ErrorPage';

export default function App(): JSX.Element {
  const { getAccessTokenSilently, logout } = useAuth0();
  const getToken = async () => {
    let token = getRegistrationToken();
    if (!token) {
      token = await getAccessTokenSilently();
    }
    if (!token) {
      logout();
    }
    return await Auth0TokenManager(token);
  };

  InitAuth0TokenManager(getAccessTokenSilently);
  setupFLSApiClientAuth(getToken, logout);

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="*" element={<NotFound />} />
        <Route path="/" element={<HomePage />} />
        <Route path="/:lang" element={<LangGuard />}>
          <Route path="Error" element={<ErrorPage />} />
          <Route index element={<HomePage />} />
          {/* Nouvelles Routes */}
          <Route element={<FamiliprixPageBase />}>
            <Route index path="Confirmation-Activation" element={<ActivationConfirmation />} />
            <Route index path="Activation-Confirmation" element={<ActivationConfirmation />} />

            <Route index path="Activate-Account" element={<ActivateAccount />} />
            <Route index path="Activation-Compte" element={<ActivateAccount />} />

            <Route element={<ConsentPreferenceBase />}>
              <Route path="Modifier-Preferences" element={<PreferenceCenter />}></Route>
              <Route path="Modify-Preferences" element={<PreferenceCenter />}></Route>

              <Route path="Desabonnement" element={<UnsubscribePage />}></Route>
              <Route path="Unsubscribe" element={<UnsubscribePage />}></Route>
            </Route>
          </Route>
          <Route element={<RequireAuthGuard />}>
            <Route path="Inscription" element={<RegisterAccount />} />
            <Route path="Register" element={<RegisterAccount />} />

            <Route path="Confirmation" element={<Redirect />} />
          </Route>
          <Route element={<AuthGuardError />}>
            <Route path="Compte">
              <Route element={<MainBase />}>
                <Route path="Parametres" element={<AccountProfile />} />
                <Route path="Nouvelle-Adresse" element={<CreateAddress />} />
                <Route path="Modifier-Adresse/:id" element={<EditAddress />} />
                <Route element={<PreferencesBase />}>
                  <Route path="Preferences-Magasinage" element={<ShoppingPage />} />
                  <Route path="Preferences-Communications" element={<CommunicationPage />} />
                </Route>
              </Route>

              <Route path="Familiplus">
                <Route element={<FamiliplusBase />}>
                  <Route index element={<FamiliplusSummaryPage />} />
                  <Route path="Transactions" element={<TransactionsPage />} />
                </Route>

                <Route element={<MainBase />}>
                  <Route element={<FamiliplusSubBase />}>
                    <Route path="OES" element={<FamiliplusOESDonations />} />
                    <Route path="Carte" element={<FamiliplusCardPage />} />
                    <Route path="Changer-Ma-Carte" element={<FamiliplusReplaceCard />} />
                  </Route>
                </Route>
              </Route>
            </Route>

            <Route path="Account">
              <Route element={<MainBase />}>
                <Route path="Settings" element={<AccountProfile />} />
                <Route path="New-Address" element={<CreateAddress />} />
                <Route path="Edit-Address/:id" element={<EditAddress />} />
                <Route element={<PreferencesBase />}>
                  <Route path="Shopping-Preferences" element={<ShoppingPage />} />
                  <Route path="Communication-Preferences" element={<CommunicationPage />} />
                </Route>
              </Route>

              <Route path="Familiplus">
                <Route element={<FamiliplusBase />}>
                  <Route index element={<FamiliplusSummaryPage />} />
                  <Route path="Transactions" element={<TransactionsPage />} />
                </Route>

                <Route element={<MainBase />}>
                  <Route element={<FamiliplusSubBase />}>
                    <Route path="OES" element={<FamiliplusOESDonations />} />
                    <Route path="Card" element={<FamiliplusCardPage />} />
                    <Route path="Change-My-Card" element={<FamiliplusReplaceCard />} />
                  </Route>
                </Route>
              </Route>
            </Route>
          </Route>

          {/* Je garde les vielles routes en place pour faciliter l'implementation avec commerce pour ne pas impacter leur site pendant le deployment */}
          <Route element={<AuthGuardError />}>
            <Route path="Redirect" element={<Redirect />} />
            <Route path="familiplus">
              <Route element={<FamiliplusBase />}>
                <Route index element={<FamiliplusSummaryPage />} />
                <Route path="transactions" element={<TransactionsPage />} />
              </Route>
              <Route element={<MainBase />}>
                <Route element={<FamiliplusSubBase />}>
                  <Route path="GiveToOES" element={<FamiliplusOESDonations />} />
                  <Route path="card">
                    <Route index element={<FamiliplusCardPage />} />
                    <Route path="replace" element={<FamiliplusReplaceCard />} />
                  </Route>
                </Route>
              </Route>
            </Route>

            <Route element={<MainBase />}>
              <Route path="Account" index element={<AccountProfile />} />
              <Route path="Address/Add" element={<CreateAddress />} />
              <Route path="Address/Edit/:id" element={<EditAddress />} />
              <Route path="preferences" element={<PreferencesBase />}>
                <Route path="shopping" element={<ShoppingPage />} />
                <Route path="communications" element={<CommunicationPage />} />
              </Route>
            </Route>
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

function Layout() {
  return <Outlet />;
}
